export default __webpack_public_path__ + "static/media/jenkins-negative.4866f55c.svg";